import { Component } from '@angular/core';
import { ROUTES } from "@coreConstant";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import {
  FlooringWallingBannerSectionComponent
} from "../flooring-walling-banner-section/flooring-walling-banner-section.component";
import { AiChatComponent } from "../ai-chat/ai-chat.component";
import { filter, map, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    FooterComponent,
    HeaderComponent,
    RouterOutlet,
    FlooringWallingBannerSectionComponent,
    AiChatComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  showBanner = false;
  private destroy$ = new Subject<void>();

  /**
   * Represents a constant object or variable that holds route definitions
   * for an application. Typically used to define and map paths or URLs
   * to specific components, pages, or handlers within a routing system.
   *
   * The structure of ROUTES may include keys representing the route names
   * and their respective values being the paths or configurations linked
   * to those routes.
   *
   * This variable is often utilized in frameworks or libraries that
   * involve client-side or server-side routing to standardize and centralize
   * route management across the application.
   *
   * Note: Ensure ROUTES is correctly configured to align with the application's
   * navigation and routing logic.
   */
  protected readonly ROUTES = ROUTES;

  /**
   * Creates an instance of the class.
   *
   * @param {Router} router - An instance of the Router to manage navigation and routes.
   * @return {void}
   */
  constructor(
    public router: Router, private route: ActivatedRoute
  ) {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.rootRoute(this.route)),
      map((activeRoute: ActivatedRoute) => activeRoute.snapshot.data),
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      this.showBanner = data['showBanner'] || false;
    });
  }

  rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
